import * as React from 'react'
import { isServer } from '../constants/routing'

export const useIsoLayoutEffect = isServer
  ? React.useEffect
  : React.useLayoutEffect
